
<template>
  <div class="rule" v-if="isShowRuleDetail">
    <div class="rule-title" @click="openRulePopup">
      <span>{{getTitle}}</span>
      <svg xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="vertical-align:middle" ><path  fill-rule="nonzero" d="M16.061 4.94l16.12 15.878a4.5 4.5 0 0 1 0 6.364l-16.12 15.879a1.5 1.5 0 0 1-2.122-2.122L30.06 25.061a1.5 1.5 0 0 0 0-2.122L13.94 7.061a1.5 1.5 0 1 1 2.121-2.122z"/></svg>
    </div>
     <Popup :isShow="isShowRule" :title="getTitle" @clickMask="isShowRule = false">
      <div class="popup-wrapper" slot="content">
        <div class="rules-wrapper">
            <div class="rule-list">{{ruleDesc}}</div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import Popup from '@/components/vant-popup'
export default {
  name: 'couponRule',
  props: ['ruleDesc'],
  computed: {
    getTitle () {
      return this.$t('FoodC_C_Terms_and_eAhU')
    },
    isShowRuleDetail () {
      return this.ruleDesc
    }
  },
  components: {
    Popup
  },
  data () {
    return {
      isShowRule: false
    }
  },
  methods: {
    openRulePopup () {
      this.isShowRule = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.rule
  .rule-title
    display flex
    align-items center
    height: 28px;
    margin: 0 40px;
    span {
      font-family: 'Aspira Light';
      font-size: 28px;
      // font-weight: 200;
    }
    svg
      width 28px
      height 28px

.popup-wrapper
  margin-top 43px
  height 100%
  overflow-y auto
.rules-wrapper
  overflow hidden
.rule-list
  margin-bottom 34px
  font-family 'PingFangSC Thin'
  font-size 28px
  color #000000
  line-height 34px
  font-weight 200
  word-break break-all
  white-space normal
</style>